import { isDoStatement } from 'typescript';
import { addDialCode, OTP_ACTIONS } from '../../utils/constants';
import { ResponseBody } from '../middleware';
import { DORMANT_PAN_CHECK_SUCCESS, REGISTER_DORMANT_SUCCESS } from '../types/links';
import {
    AuthState,
    AuthTypes,
    GET_NOTIFICATIONS_SUCCESS,
    LOGOUT_SUCCESS,
    SET_PASSWORD,
    SIGNUP,
    VALIDATE_SECRET_ANSWER_SUCCESS,
    REDIRECT_ACTION,
    LOGIN_SUCCESS,
    FORGOT_PASSWORD_SUCCESS,
    SIGNUP_SUCCESS,
    UPDATE_FIRST_TIME_SETTINGS,
    MOBILE_SESSION_OUT,
    MOBILE_SESSION_FORCE_LOGOUT,
    FORGOT_QUESTION_ANSWER_OTP_SUCCESS,
    SET_IS_FROM_PRE_LOGIN,
    SET_MF_NEW,
    CLEAR_POPUP_STATUS,
} from '../types/login';
import { MOBILE_LOGIN_SUCCESS } from '../types/mobile';
import {
    SEND_EMAIL_OTP_SUCCESS,
    SEND_SMS_OTP_SUCCESS,
    SAVE_DISPLAY_NAME_SUCCESS,
} from '../types/nct';

const initState: Partial<AuthState> = {
    token: null,
    notificationCount: 0,
    redirectPath: null,
    isLoggedOut: false,
    isLoggedIn: false,
    firstTimeLoggedIn: true,
    enableTwoFactorAuth: false,
    appTourVisited: false,
    enabledPin: false,
    isFromPreLogin: false,
    backupPin: '',
    newToMF: '',
};

function authReducer(state = initState, action: AuthTypes & ResponseBody<any>) {
    switch (action.type) {
        case SIGNUP_SUCCESS:
        case SEND_SMS_OTP_SUCCESS:
        case SEND_EMAIL_OTP_SUCCESS:
        case FORGOT_PASSWORD_SUCCESS:
        case FORGOT_QUESTION_ANSWER_OTP_SUCCESS:
        case REGISTER_DORMANT_SUCCESS:
        case LOGIN_SUCCESS: {
            const { userSubjectReference, userRegisteredWith } = action.body;
            return {
                ...state,
                token: state.isLoggedIn ? state.token : userSubjectReference || state.token,
            };
        }
        case DORMANT_PAN_CHECK_SUCCESS: {
            const { userSubjectReference, userRegisteredWith } = action.body;
            return {
                ...state,
                token: userSubjectReference,
            };
        }
        case SET_PASSWORD: {
            return state;
        }
        case VALIDATE_SECRET_ANSWER_SUCCESS:
        case MOBILE_LOGIN_SUCCESS: {
            const { userSubjectReference = '', mobile, email, pan, ...rest } = action.body;
            const _mobile = !!mobile ? addDialCode(mobile) : '';
            return {
                ...state,
                ...rest,
                email,
                token: !!userSubjectReference ? userSubjectReference : state.token,
                mobile: _mobile,
                displayMobile: _mobile.slice(3),
                isLoggedIn: !!userSubjectReference,
                ...{ pan: rest.action === OTP_ACTIONS.forgot_password ? null : pan },
            };
        }
        case SET_MF_NEW: {
            const { newToMF } = action.body;
            return {
                ...state,
                newToMF,
            };
        }
        case CLEAR_POPUP_STATUS: {
            return {
                ...state,
                showPopUp: 'N',
            };
        }
        case GET_NOTIFICATIONS_SUCCESS: {
            const { notifications = [] } = action.body;
            return {
                ...state,
                notificationCount: notifications.length,
            };
        }
        case LOGOUT_SUCCESS: {
            // if (!action.isTimeout) {
            //     window.location.reload();
            // }
            return { ...initState, isLoggedOut: true, firstTimeLoggedIn: false };
        }
        case REDIRECT_ACTION: {
            const { redirectPath = '/', isLoggedOut = false } = action.body;
            return {
                ...state,
                redirectPath,
                isLoggedOut,
            };
        }
        case SET_IS_FROM_PRE_LOGIN: {
            const isFromPreLogin = !!action.body;
            return {
                ...state,
                isFromPreLogin,
            };
        }
        case UPDATE_FIRST_TIME_SETTINGS: {
            const { body = {} } = action;
            return { ...state, ...body };
        }
        case SAVE_DISPLAY_NAME_SUCCESS: {
            const { newDisplayName = '' } = action.body;
            return {
                ...state,
                displayName: newDisplayName,
            };
        }
        case MOBILE_SESSION_OUT:
        case MOBILE_SESSION_FORCE_LOGOUT: {
            const {
                appTourVisited,
                enableTwoFactorAuth,
                enabledPin,
                firstTimeLoggedIn,
                mobile,
                pan,
                pekrn,
                displayName,
                initialSettingsAsked,
                ...rest
            } = state;
            // handling session out in pin set screen // Web logout
            if (!enabledPin) {
                return { ...initState, isLoggedOut: true, firstTimeLoggedIn: false };
            }
            return {
                ...initState,
                initialSettingsAsked,
                firstTimeLoggedIn,
                appTourVisited,
                mobile,
                pan,
                pekrn,
                displayName,
                enableTwoFactorAuth,
                enabledPin,
            };
        }
        default:
            return state;
    }
}

export default authReducer;
